import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { DeviceMobileIcon, MonitorIcon } from '@phosphor-icons/react'

import { previewViewModes } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/constants'

const usePreviewViewMode = ({ onChange }) => {
  const { t } = useTranslation()
  const [viewMode, setViewMode] = useState(previewViewModes.desktop)

  const selectViewMode = newViewMode => {
    if (newViewMode === viewMode) return

    onChange(viewMode)
    setViewMode(newViewMode)
  }

  const viewModeOptions = [
    {
      id: previewViewModes.mobile,
      Icon: DeviceMobileIcon,
      label: t('Móvil'),
      onClick: () => selectViewMode(previewViewModes.mobile),
    },
    {
      id: previewViewModes.desktop,
      Icon: MonitorIcon,
      label: t('Escritorio'),
      onClick: () => selectViewMode(previewViewModes.desktop),
    },
  ]

  const isMobileView = viewMode === previewViewModes.mobile

  return { viewMode, viewModeOptions, isMobileView, setViewMode }
}

export default usePreviewViewMode
